import { render, staticRenderFns } from "./PriceSelector.vue?vue&type=template&id=4972902c&scoped=true&"
import script from "./PriceSelector.vue?vue&type=script&lang=js&"
export * from "./PriceSelector.vue?vue&type=script&lang=js&"
import style0 from "./PriceSelector.vue?vue&type=style&index=0&id=4972902c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4972902c",
  null
  
)

export default component.exports